import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GoogleMap, Marker, Circle, InfoWindow } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next';
import { getDevice } from '@panel/commons/helpers';
import customMarker from '../../../../assets/icons/custom_marker.svg';
import { locationStepSelectors, locationStepOperations } from '../../../ducks/location';
import CloseIcon from '../../../../assets/icons/close.svg';
import { setCoordinates } from '../../../ducks/location/operations';
import {
  ContainerMap,
  MapWrapper,
  InfoWindowText,
  VisibilityOptionsAddressWrapper,
  Title,
  SwitchLocationLabel,
  TitleWrapper,
  CloseButton,
  InfoWindowContainer
} from './styles';
import FormSwitch from '../../commons/FormSwitch';

const options = {
  disableDefaultUI: true,
  zoomControl: true,
  controlSize: 24
};
const radiusOptions = {
  fillColor: '#C60024',
  fillOpacity: '0.2',
  strokeOpacity: '0'
};

export const MapSection = ({ isLoaded, loadError }) => {
  const [viewInfoWindow, setViewInfoWindow] = useState(true);
  const { hasCoordinates, formValues, visibility } = useSelector(locationStepSelectors.getLocationStepState);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isMobile = getDevice() === 'mobile';

  const { selectedCity } = formValues;
  const { lat, lng } = hasCoordinates;

  const mapStyles = {
    height: `292px`,
    width: '100%'
  };

  const handleSwitchChange = value => {
    dispatch(locationStepOperations.setVisibility(value));
  };

  const handleOnDrag = onDrag => {
    const { lat: newLat, lng: newLng } = onDrag.latLng;
    const coordinates = { lat: newLat(), lng: newLng() };
    // setViewInfoWindow(true);
    dispatch(setCoordinates(coordinates));
  };

  const onDragHideInfoWindow = () => {
    setViewInfoWindow(false);
  };

  if (!isLoaded) {
    return 'Loading Maps';
  }

  return (
    <ContainerMap data-publi='locationStep-mapSection-container'>
      {selectedCity && (lat || lng) && (
        <>
          <TitleWrapper>
            <Title data-publi='locationStep-mapSection-title' isMobile={isMobile}>
              {t('professionalPubli.location.subtitle')}
            </Title>
          </TitleWrapper>
          <VisibilityOptionsAddressWrapper>
            <SwitchLocationLabel>{t('professionalPubli.location.switch.exact')}</SwitchLocationLabel>
            <FormSwitch
              id={'switchLocationType'}
              dataPanel={'location-map-switch'}
              value={visibility === 'EXACT'}
              handleSwitchChange={() => handleSwitchChange(visibility === 'EXACT' ? 'ZONE' : 'EXACT')}
            />
          </VisibilityOptionsAddressWrapper>
          <MapWrapper>
            <GoogleMap
              data-publi='locationStep-mapSection-googleMapContainer'
              mapContainerStyle={mapStyles}
              zoom={16}
              center={{ lat, lng }}
              options={options}
              radius={16}
            >
              {visibility === 'EXACT' && (
                <Marker
                  position={{ lat, lng }}
                  draggable
                  onDragEnd={handleOnDrag}
                  onDrag={onDragHideInfoWindow}
                  icon={{ url: customMarker }}
                />
              )}
              {visibility === 'EXACT' && viewInfoWindow && (
                <InfoWindow
                  position={{ lat, lng }}
                  options={{ pixelOffset: new window.google.maps.Size(0, 80), headerDisabled: true }}
                  style={{ backgroundColor: 'red' }}
                >
                  <InfoWindowContainer>
                    <InfoWindowText data-publi='locationStep-mapSection-infoWindowText'>
                      {t('professionalPubli.location.marker')}
                    </InfoWindowText>
                    <CloseButton onClick={() => setViewInfoWindow(false)}>
                      <img src={CloseIcon} alt='Close icon' width={'18px'} />
                    </CloseButton>
                  </InfoWindowContainer>
                </InfoWindow>
              )}
              {visibility === 'ZONE' && <Circle center={{ lat, lng }} radius={250} options={radiusOptions} />}
            </GoogleMap>
            {loadError && <p data-publi='locationStep-mapSection-laodingMapError'>Error loading map</p>}
          </MapWrapper>
        </>
      )}
    </ContainerMap>
  );
};
